import { useMemo } from 'react';
import { useClient } from 'urql';
import { fromPromise } from 'xstate5';

import {
  type CancelPreviousIntentParams,
  type CancelPreviousIntentResponse,
} from '@order/features/ordering';

import {
  BagCancelPreviousIntentDocument,
  type BagCancelPreviousIntentMutation,
} from '../../GraphQL/BagCancelPreviousIntent.generated';

export const useBagCancelPreviousIntent = () => {
  const client = useClient();

  const cancelPreviousIntent = useMemo(
    () =>
      fromPromise<CancelPreviousIntentResponse, CancelPreviousIntentParams>(
        async ({ input }) => {
          const { paymentIntentId } = input;
          const mutation = client.mutation<BagCancelPreviousIntentMutation>;

          if (!paymentIntentId)
            throw new Error('Payment intent ID is required');

          const response = await mutation(BagCancelPreviousIntentDocument, {
            input: { paymentIntentId },
          }).toPromise();

          const maybeData = response.data?.cancelOrderPaymentIntent;

          return {
            paymentIntentId,
            success: Boolean(maybeData?.success),
          };
        },
      ),
    [client.mutation],
  );

  return { cancelPreviousIntent };
};
